import Image from "next/image";
import React from "react";
import styled, { css, DefaultTheme } from "styled-components";
import { useRouter } from "next/router";
import { useWindowDimensions } from "../../hooks/useWindowSize";
import { socialList } from "../../util/dackieSocials";
import { Flex } from "../Box";
import { Link } from "../Link";
import { FooterProps } from "./types";
import { DackieText } from "../Svg";

interface CustomProps extends DefaultTheme {
  isLiquidityPage?: boolean;
  isMobileDevice?: boolean;
}

const FooterWrapper = styled.div<CustomProps>`
  background-color: ${({ theme }) => (theme.isDark ? "#1b204b" : "#f1f5ff")};
  position: relative;
  padding: 20px 16px;
  top: ${(props) =>
          props.isLiquidityPage && props.isMobileDevice
                  ? "90px"
                  : props.isLiquidityPage && !props.isMobileDevice
                          ? "130px"
                          : "-1px"};
  .dackie-swap-title {
    font-weight: 800;
    font-size: 20px;
    color: #181818;
  }
  /* @media screen and (max-width: 515px) {
    position: relative;
    bottom: 40px;
  } */
  @media screen and (max-width: 851px) {
    margin-bottom: 44px;
  }
`;

const MenuItem: React.FC<React.PropsWithChildren<FooterProps>> = ({
                                                                    items,
                                                                    isDark,
                                                                    toggleTheme,
                                                                    currentLang,
                                                                    langs,
                                                                    setLang,
                                                                    cakePriceUsd,
                                                                    buyCakeLabel,
                                                                    buyCakeLink,
                                                                    chainId,
                                                                    ...props
                                                                  }) => {
  const { width } = useWindowDimensions();

  const isMobileDevice = width <= 768;

  const turntextColor = isDark ? "#fff" : "#181818";

  const { pathname } = useRouter();

  const isLiquidityPage = pathname.includes("/liquidity");

  return (
    // @ts-ignore
    <FooterWrapper
      data-theme={isDark ? "dark" : "light"}
      p={["20px 16px", null, "20px 20px 20px 20px"]}
      position="relative"
      isLiquidityPage={isLiquidityPage}
      isMobileDevice={isMobileDevice}
      {...props}
    >
      <FlexExtend>
        <div className="flex-1 dackie-logo">
          <Link style={{ textDecoration: "none" }} href="https://dackieofficial.com/">
            <Flex style={{ alignItems: "center", gap: 15 }}>
              <Image src="/images/home/dackie/dackie_official.png" alt="" width={45} height={45} />
              {isMobileDevice ? null : <DackieText color={turntextColor} style={{ width: 75 }} />}
            </Flex>
          </Link>
        </div>
        <div className=" flex-1 social-logo">
          <Flex
            style={{
              gap: isMobileDevice ? 20 : 30,
              height: "100%",
              padding: "0 15px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {socialList.map((item) => {
              const Icon = item.src;
              if (item.title === "galxe") {
                return (
                  <IconWrapper key={`${10}${item.src}`}>
                    <a target="_blank" href={item.to} rel="noopener noreferrer">
                      <Icon
                        style={{
                          background: "#000",
                          borderRadius: "100%",
                          padding: 2,
                        }}
                      />
                    </a>
                  </IconWrapper>
                );
              }
              return (
                <IconWrapper key={`${1000}${item.src}`}>
                  <a target="_blank" href={item.to} rel="noopener noreferrer">
                    <Icon color={isDark ? "#fff" : "#000"} />
                  </a>
                </IconWrapper>
              );
            })}
          </Flex>
        </div>
        <div className="flex-1 swap-logo">
          <Link style={{ textDecoration: "none" }} href="/#">
            <Flex style={{ alignItems: "center", gap: 15 }}>
              <Image src="/images/home/dackie/dackieLogo.png" alt="" width={45} height={45} />
              {isMobileDevice ? null : (
                <h1
                  style={{
                    color: turntextColor,
                  }}
                  className="dackie-swap-title"
                >
                  DackieSwap
                </h1>
              )}
            </Flex>
          </Link>
        </div>
        {/* <SkeletonV2 variant="round" width="56px" isDataReady={isMounted}>
          <ThemeSwitcher isDark={isDark} toggleTheme={toggleTheme} />
        </SkeletonV2> */}
      </FlexExtend>
    </FooterWrapper>
  );
};

const IconWrapper = styled.div`
  transition: all 0.3s ease;
  cursor: pointer;
  &:hover {
    transform: translateY(-3px);
  }
`;

const FlexExtend = styled(Flex)`
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  .flex-1 {
    flex: 1;
  }
  .swap-logo {
    display: flex;
    justify-content: flex-end;
  }
  /* @media screen and (max-width: 515px) {
    .social-logo {
      padding: 25px 0 35px 0;
      border-top: 1px solid #0ca7ff;
      flex: 1;
    }
  }
  @media screen and (max-width: 768px) {
    .swap-logo {
      order: 2;
      padding: 25px 0;
    }
    .social-logo {
      order: 3;
    }
  } */
`;
export default MenuItem;
